import Products from "@/components/Products/Products";
import Toolbar from "@/components/Toolbar/Toolbar";
import BottomToolbar from "@/components/BottomToolbar/BottomToolbar";
import {
  ContentChildrenProps,
  wrapContent,
} from "@/components/ContentWrapper/ContentWrapper";
import NoResults from "@/components/NoResults/NoResults";
import { useDecoratedSearchResults } from "@nosto/search-js/preact/hooks";

export function CategoryBody({ foundProducts, loading }: ContentChildrenProps) {
  const { products } = useDecoratedSearchResults();
  const { categoryPath, total } = products;
  const showNoResults = !foundProducts && !loading;

  return (
    <>
      <div className="plp__heading">
        {categoryPath && <h1>{categoryPath}</h1>}
        {!showNoResults && !loading && <span>{total} products</span>}
      </div>
      <Toolbar productsCount={total} showNoResults={showNoResults} />
      {showNoResults ? <NoResults /> : <Products searchTrackType="category" />}
      {!showNoResults && <BottomToolbar />}
    </>
  );
}

export default wrapContent("category", CategoryBody);
